/* HALO Size Guide v4 — simplified */
console.log('[HALO] size-guide.js loaded');

/* ─── DATA ─── */
var SIZES = [
  { s: 7,  d: 17.5, c: 55.0, min: 54.2, max: 55.7, eq: "EU 55", br: "15" },
  { s: 8,  d: 18.3, c: 57.5, min: 56.7, max: 58.2, eq: "EU 57", br: "17" },
  { s: 9,  d: 19.1, c: 60.0, min: 59.2, max: 60.8, eq: "EU 60", br: "20" },
  { s: 10, d: 20.0, c: 62.8, min: 62.1, max: 63.5, eq: "EU 62", br: "22" },
  { s: 11, d: 20.8, c: 65.3, min: 64.5, max: 66.1, eq: "EU 65", br: "25" },
  { s: 12, d: 21.6, c: 67.9, min: 67.0, max: 68.7, eq: "EU 67", br: "27" },
  { s: 13, d: 22.4, c: 70.3, min: 69.5, max: 71.2, eq: "EU 70", br: "30" }
];
var D_MIN = 16.5, D_MAX = 22.5;

/* Card dimensions (vertical orientation - portrait for mobile) */
var CARD_W = 54;     // 54mm wide (when vertical)
var CARD_H = 85.6;   // 85.6mm tall

/* ─── STATE ─── */
var pxMm = (window.devicePixelRatio || 1) * 3.78;
var calibrated = false;
var cH = 0;          // card height in pixels (the calibration target)
var cDrag = false, cSY = 0, cSH = 0;
var cDmm = 19.5;
var rPx = 0, rDrag = false, rSY = 0;
var gOpen = false;

/* ─── HELPERS ─── */
function fmt(n) { return n.toString().replace('.', ','); }
function fByD(d) {
  var best = SIZES[0], bd = Infinity;
  for (var i = 0; i < SIZES.length; i++) {
    var diff = Math.abs(SIZES[i].d - d);
    if (diff < bd) { bd = diff; best = SIZES[i]; }
  }
  return best;
}
function fByC(c) {
  for (var i = 0; i < SIZES.length; i++) {
    if (c >= SIZES[i].min && c <= SIZES[i].max) return SIZES[i];
  }
  return c < SIZES[0].min ? SIZES[0] : SIZES[SIZES.length - 1];
}

/* ─── TOGGLE GUIDE ─── */
function haloToggleG() {
  gOpen = !gOpen;
  var gw = document.getElementById('halo-gw');
  var d = document.getElementById('halo-disc');
  if (gw) gw.classList.toggle('open', gOpen);
  if (d) {
    d.classList.toggle('open', gOpen);
    d.setAttribute('aria-expanded', String(gOpen));
  }
  if (gOpen) {
    setTimeout(function() {
      haloInitCalib();
      haloBuildTable();
    }, 600);
  }
}

/* ─── TABS ─── */
function haloPT(n) {
  var panes = document.querySelectorAll('.halo-pane');
  var tabs = document.querySelectorAll('.halo-mt');
  for (var i = 0; i < panes.length; i++) panes[i].classList.toggle('on', i === n);
  for (var j = 0; j < tabs.length; j++) tabs[j].classList.toggle('on', j === n);
}

/* ─── TABLE ─── */
function haloBuildTable() {
  var tb = document.getElementById('halo-tblb');
  if (!tb) return;
  var html = '';
  for (var i = 0; i < SIZES.length; i++) {
    var sz = SIZES[i];
    html += '<tr><td>' + sz.s + '</td>'
         + '<td>' + sz.br + '</td>'
         + '<td>' + fmt(sz.c) + ' mm</td>'
         + '<td>' + fmt(sz.d) + ' mm</td></tr>';
  }
  tb.innerHTML = html;
}

/* ─── CALIBRATION (vertical card) ─── */
function haloInitCalib() {
  var stage = document.getElementById('halo-cs');
  if (!stage) return;
  calibrated = false;
  // Initial card height: 60% of stage, bounded
  var stageH = stage.offsetHeight - 80;
  if (stageH < 100) stageH = 300;
  cH = Math.max(200, Math.min(360, Math.floor(stageH * 0.6)));
  haloUpdateCard();

  var rw = document.getElementById('halo-rw');
  var cw = document.getElementById('halo-cw');
  if (rw) rw.style.display = 'none';
  if (cw) cw.style.display = '';
}

function haloUpdateCard() {
  var co = document.getElementById('halo-co');
  if (!co) return;
  var w = Math.round(cH * (CARD_W / CARD_H));
  co.style.width = w + 'px';
  co.style.height = cH + 'px';
  pxMm = cH / CARD_H;
  var ppi = Math.round(pxMm * 25.4);
  var ok = ppi >= 72 && ppi <= 600;
  // Toggle calibrating visual state
  if (ok) co.classList.add('calibrating');
  else co.classList.remove('calibrating');
  var dot = document.getElementById('halo-cdot');
  var txt = document.getElementById('halo-ctxt');
  var ppiEl = document.getElementById('halo-cppi');
  var lbl = document.getElementById('halo-co-lbl');
  if (dot) dot.className = 'halo-cdot' + (ok ? ' ok' : '');
  if (txt) txt.textContent = ok ? 'Calibrado: ' + ppi + ' PPI' : 'Arraste a borda para encaixar no cartão';
  if (ppiEl) ppiEl.textContent = ppi > 0 ? ppi + ' PPI' : '';
  if (lbl) lbl.textContent = ok ? 'Encaixado' : 'Cartão na vertical';
}

function haloConfirmCalib() {
  calibrated = true;
  var cw = document.getElementById('halo-cw');
  var rw = document.getElementById('halo-rw');
  if (cw) cw.style.display = 'none';
  if (rw) rw.style.display = 'block';
  haloInitRing();
}

/* Drag handlers (vertical drag) */
function cS(e) {
  cDrag = true;
  cSY = e.touches ? e.touches[0].clientY : e.clientY;
  cSH = cH;
  e.preventDefault();
}
function cM(e) {
  if (!cDrag) return;
  var y = e.touches ? e.touches[0].clientY : e.clientY;
  var stage = document.getElementById('halo-cs');
  var sh = stage ? (stage.offsetHeight - 60) : 400;
  cH = Math.max(140, Math.min(sh - 6, cSH + (y - cSY)));
  haloUpdateCard();
  e.preventDefault();
}
function cE() { cDrag = false; }

/* ─── RING SIZER ─── */
function haloInitRing() {
  haloGuides();
  rPx = cDmm * pxMm;
  haloUpdateRing(rPx);
  var sl = document.getElementById('halo-sl');
  if (sl) {
    var p = (cDmm - D_MIN) / (D_MAX - D_MIN);
    sl.value = Math.round(p * 100);
    sl.style.setProperty('--p', Math.round(p * 100) + '%');
  }
}

function haloGuides() {
  var g = document.getElementById('halo-rgw');
  if (!g) return;
  g.innerHTML = '';
  for (var i = 0; i < SIZES.length; i++) {
    var px = SIZES[i].d * pxMm;
    var el = document.createElement('div');
    el.className = 'halo-gr';
    el.style.width = px + 'px';
    el.style.height = px + 'px';
    g.appendChild(el);
  }
}

function haloUpdateRing(px) {
  var mm = px / pxMm;
  cDmm = mm;
  var sizer = document.getElementById('halo-rsz');
  var hole = document.getElementById('halo-rh');
  if (!sizer || !hole) return;
  var wall = Math.max(7, 3 * pxMm);
  sizer.style.width = px + 'px';
  sizer.style.height = px + 'px';
  var hPx = Math.max(8, px - wall * 2);
  hole.style.width = hPx + 'px';
  hole.style.height = hPx + 'px';
  var rdd = document.getElementById('halo-rdd');
  var rds = document.getElementById('halo-rds');
  if (rdd) rdd.textContent = mm.toFixed(1);
  var sz = fByD(mm);
  if (rds) rds.textContent = sz.s;
  var diff = mm - sz.d;
  var hint = document.getElementById('halo-ph');
  if (hint) {
    if (Math.abs(diff) < 0.25) {
      hint.textContent = 'Tamanho ' + sz.s + ': encaixe perfeito';
      hint.className = 'halo-ph m';
    } else {
      hint.textContent = 'Ajuste o círculo ao diâmetro interno do anel';
      hint.className = 'halo-ph';
    }
  }
}

function rS(e) {
  rDrag = true;
  rSY = e.touches ? e.touches[0].clientY : e.clientY;
  e.preventDefault();
}
function rM(e) {
  if (!rDrag) return;
  var y = e.touches ? e.touches[0].clientY : e.clientY;
  var dy = y - rSY;
  rSY = y;
  rPx = Math.max(D_MIN * pxMm, Math.min(D_MAX * pxMm, rPx + dy * 2));
  haloUpdateRing(rPx);
  var mm = rPx / pxMm;
  var pct = (mm - D_MIN) / (D_MAX - D_MIN);
  var sl = document.getElementById('halo-sl');
  if (sl) {
    sl.value = Math.round(pct * 100);
    sl.style.setProperty('--p', Math.round(pct * 100) + '%');
  }
  e.preventDefault();
}
function rE() { rDrag = false; }

function haloOnSl(v) {
  var mm = D_MIN + (v / 100) * (D_MAX - D_MIN);
  cDmm = mm;
  rPx = mm * pxMm;
  haloUpdateRing(rPx);
  var sl = document.getElementById('halo-sl');
  if (sl) sl.style.setProperty('--p', v + '%');
}
function haloNudge(dir) {
  var sl = document.getElementById('halo-sl');
  if (!sl) return;
  var nv = Math.max(0, Math.min(100, parseInt(sl.value) + dir * 3));
  sl.value = nv;
  haloOnSl(nv);
}

/* ─── METHOD B: TYPE MEASUREMENT ─── */
function haloCalcB() {
  var inp = document.getElementById('halo-vc');
  if (!inp) return;
  var v = parseFloat(inp.value);
  if (isNaN(v)) {
    haloHideResult();
    return;
  }
  if (v < 53 || v > 70) {
    inp.classList.add('err');
    var err = document.getElementById('halo-verr');
    if (err) {
      err.textContent = 'Valor fora do intervalo. Use entre 53 e 70 mm.';
      err.classList.add('show');
    }
    haloHideResult();
    return;
  }
  inp.classList.remove('err');
  var err2 = document.getElementById('halo-verr');
  if (err2) err2.classList.remove('show');
  haloShowResult(fByC(v));
}

function haloShowResult(sz) {
  var card = document.getElementById('halo-lc');
  if (!card) return;
  card.classList.add('show');
  var n = document.getElementById('halo-lcn');
  var nm = document.getElementById('halo-lcnm');
  var sp = document.getElementById('halo-lcsp');
  if (n) n.textContent = sz.s;
  if (nm) nm.textContent = 'Tamanho ' + sz.s;
  if (sp) sp.textContent = 'Ø ' + fmt(sz.d) + 'mm · Circ. ' + fmt(sz.c) + 'mm';
}

function haloHideResult() {
  var card = document.getElementById('halo-lc');
  if (card) card.classList.remove('show');
}


/* ─── HELP MODAL ─── */
var HELP_CONTENT = {
  calib: {
    title: 'Como calibrar a tela',
    steps: [
      {
        svg: '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          // Wallet behind
          '<path d="M22 78 L22 50 Q22 44 28 44 L88 44 Q94 44 94 50 L94 86 Q94 92 88 92 L28 92 Q22 92 22 86 Z" fill="#8B6F47" stroke="#6B5538" stroke-width="1.5"/>' +
          '<rect x="22" y="62" width="72" height="3" fill="#6B5538" opacity=".3"/>' +
          // Card emerging from wallet (tilted, perspective)
          '<g transform="rotate(-8 60 40)">' +
            '<rect x="32" y="14" width="56" height="36" rx="4" fill="#FFF" stroke="#0F0F0E" stroke-width="1.8"/>' +
            // Bank logo placeholder
            '<rect x="38" y="20" width="14" height="6" rx="1" fill="#0171E3"/>' +
            // Chip
            '<rect x="38" y="30" width="10" height="8" rx="1.2" fill="#E8C547" stroke="#A88820" stroke-width="0.8"/>' +
            '<line x1="40" y1="33" x2="46" y2="33" stroke="#A88820" stroke-width="0.4"/>' +
            '<line x1="40" y1="35" x2="46" y2="35" stroke="#A88820" stroke-width="0.4"/>' +
            // Card number dots
            '<text x="54" y="36" font-family="DM Mono, monospace" font-size="3.2" fill="#0F0F0E" font-weight="700">**** 4523</text>' +
            // Card brand circles
            '<circle cx="78" cy="40" r="3" fill="#EB001B" opacity=".85"/>' +
            '<circle cx="82" cy="40" r="3" fill="#F79E1B" opacity=".85"/>' +
          '</g>' +
          // Hand pulling card (simplified)
          '<path d="M88 30 Q92 28 96 30 L102 36 Q104 40 100 42 L88 44" fill="#F4C9A0" stroke="#0F0F0E" stroke-width="1.2" stroke-linejoin="round"/>' +
          // Motion arrows
          '<path d="M104 18 L110 14 M108 12 L110 14 L108 16" stroke="#0171E3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
          // Label
          '<text x="60" y="108" font-family="DM Sans, sans-serif" font-size="9" fill="#0171E3" font-weight="700" text-anchor="middle">Qualquer cartão padrão</text>' +
          '<text x="60" y="116" font-family="DM Mono, monospace" font-size="6" fill="#6B6B66" text-anchor="middle" letter-spacing=".5">85,6 × 54 mm</text>' +
          '</svg>',
        text: 'Pegue um cartão padrão (banco, crédito ou CPF). Todos têm exatamente 85,6 × 54 mm.'
      },
      {
        svg: '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          // Phone (vertical, with bezel and notch)
          '<rect x="30" y="6" width="60" height="108" rx="10" fill="#1a1a1a" stroke="#0F0F0E" stroke-width="1.5"/>' +
          '<rect x="34" y="14" width="52" height="92" rx="3" fill="#F8F8F7"/>' +
          // Notch
          '<rect x="52" y="6" width="16" height="3" rx="1.5" fill="#0F0F0E"/>' +
          // Speaker
          '<rect x="56" y="9" width="8" height="1" rx=".5" fill="#444"/>' +
          // Page mock content
          '<rect x="38" y="20" width="20" height="3" rx="1" fill="#0F0F0E" opacity=".15"/>' +
          '<rect x="38" y="26" width="44" height="2" rx="1" fill="#0F0F0E" opacity=".08"/>' +
          // Calibration target rectangle (dashed blue) on screen
          '<rect x="44" y="34" width="32" height="50" rx="2" fill="rgba(1,113,227,0.05)" stroke="#0171E3" stroke-width="1.8" stroke-dasharray="3 2"/>' +
          // Card overlay on top (with shadow underneath)
          '<rect x="44" y="36" width="32" height="50" rx="2" fill="#000" opacity=".12"/>' +
          '<g transform="translate(43 35)">' +
            '<rect x="0" y="0" width="32" height="50" rx="2" fill="#FFF" stroke="#0F0F0E" stroke-width="1.5" opacity=".97"/>' +
            // Mini bank logo
            '<rect x="3" y="4" width="8" height="3" rx=".5" fill="#0171E3"/>' +
            // Mini chip
            '<rect x="3" y="11" width="6" height="4.5" rx=".7" fill="#E8C547" stroke="#A88820" stroke-width="0.4"/>' +
            // Number
            '<text x="3" y="24" font-family="DM Mono, monospace" font-size="2.5" fill="#0F0F0E" font-weight="700">**** 4523</text>' +
            // Brand
            '<circle cx="22" cy="40" r="3" fill="#EB001B" opacity=".85"/>' +
            '<circle cx="26" cy="40" r="3" fill="#F79E1B" opacity=".85"/>' +
          '</g>' +
          // Down arrow showing "place on screen"
          '<path d="M60 105 L60 113 M56 109 L60 113 L64 109" stroke="#0171E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
          // Side label
          '<path d="M82 50 Q90 50 92 56" stroke="#0171E3" stroke-width="1.2" stroke-linecap="round" fill="none" opacity=".6"/>' +
          '<text x="100" y="55" font-family="DM Sans, sans-serif" font-size="7" fill="#0171E3" font-weight="700" text-anchor="middle">Cartão</text>' +
          '<text x="100" y="64" font-family="DM Sans, sans-serif" font-size="7" fill="#0171E3" font-weight="700" text-anchor="middle">na tela</text>' +
          '</svg>',
        text: 'Coloque o cartão sobre a tela do celular, na vertical, alinhado com o retângulo azul.'
      },
      {
        svg: '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          // Phone outline
          '<rect x="22" y="8" width="76" height="104" rx="8" fill="#FFF" stroke="#0F0F0E" stroke-width="1.5"/>' +
          // Calibration rectangle (initial size, smaller)
          '<rect x="44" y="20" width="32" height="42" rx="2" fill="rgba(1,113,227,0.08)" stroke="#0171E3" stroke-width="2"/>' +
          // Ghost of expanded rectangle (where card actually is)
          '<rect x="44" y="20" width="32" height="58" rx="2" fill="none" stroke="#0171E3" stroke-width="1.2" stroke-dasharray="2 2" opacity=".5"/>' +
          // Card shape (where the card actually sits — the target)
          '<rect x="44" y="20" width="32" height="58" rx="2" fill="rgba(255,255,255,0.6)" stroke="#0F0F0E" stroke-width="1" stroke-dasharray="3 3" opacity=".4"/>' +
          '<text x="60" y="50" font-family="DM Mono, monospace" font-size="3.5" fill="#0F0F0E" font-weight="700" text-anchor="middle" opacity=".4">CARTÃO</text>' +
          // Drag handle (current position)
          '<circle cx="60" cy="62" r="6" fill="#0171E3" stroke="#FFF" stroke-width="2"/>' +
          '<path d="M60 59v6 M58 64l2 2 2-2 M58 60l2-2 2 2" stroke="#FFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
          // Motion arrow showing drag direction (from current to target)
          '<path d="M76 64 Q86 70 86 78" stroke="#0171E3" stroke-width="2" stroke-linecap="round" stroke-dasharray="2 2" fill="none"/>' +
          '<path d="M82 76 L86 78 L84 82" stroke="#0171E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
          // Finger (illustrative)
          '<g transform="translate(72 60)">' +
            '<path d="M0 0 Q4 -2 8 0 L10 16 Q10 20 6 20 L2 20 Q-2 20 -2 16 Z" fill="#F4C9A0" stroke="#0F0F0E" stroke-width="1"/>' +
            '<ellipse cx="4" cy="-2" rx="3.5" ry="1.5" fill="#FFE5C4" stroke="#0F0F0E" stroke-width="0.6"/>' +
          '</g>' +
          // Label below
          '<text x="60" y="100" font-family="DM Sans, sans-serif" font-size="8" fill="#0171E3" font-weight="700" text-anchor="middle">Arraste para baixo</text>' +
          '<text x="60" y="108" font-family="DM Sans, sans-serif" font-size="6.5" fill="#6B6B66" text-anchor="middle">até bater na borda do cartão</text>' +
          '</svg>',
        text: 'Arraste a bolinha azul para baixo até a borda inferior do retângulo bater na borda inferior do cartão.'
      },
      {
        svg: '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          // Phone with green calibrated state
          '<rect x="22" y="8" width="76" height="104" rx="8" fill="#FFF" stroke="#0F0F0E" stroke-width="1.5"/>' +
          // Green calibrated rectangle (full card size)
          '<rect x="44" y="20" width="32" height="58" rx="2" fill="rgba(21,128,61,0.08)" stroke="#15803D" stroke-width="2"/>' +
          // Big checkmark in center
          '<circle cx="60" cy="49" r="14" fill="#15803D"/>' +
          '<path d="M53 49l5 5 9-10" stroke="#FFF" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
          // Status pill at bottom
          '<rect x="32" y="86" width="56" height="14" rx="7" fill="#F0FDF4" stroke="#15803D" stroke-width="1.2"/>' +
          '<circle cx="40" cy="93" r="2" fill="#15803D"/>' +
          '<text x="50" y="95.5" font-family="DM Sans, sans-serif" font-size="6.5" fill="#15803D" font-weight="700">Calibrado · 320 PPI</text>' +
          // Confirm button below phone
          '<rect x="30" y="106" width="60" height="10" rx="5" fill="#0171E3"/>' +
          '<text x="60" y="113" font-family="DM Sans, sans-serif" font-size="6" fill="#FFF" font-weight="700" text-anchor="middle">Confirmar →</text>' +
          '</svg>',
        text: 'Quando o status ficar verde com "Calibrado", clique em "Confirmar e ajustar o anel".'
      }
    ]
  },
  measure: {
    title: 'Como medir o dedo',
    steps: [
      {
        svg: '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          // Paper sheet
          '<rect x="14" y="44" width="78" height="36" fill="#FFF" stroke="#0F0F0E" stroke-width="1.5"/>' +
          // Strip being cut (highlighted in blue)
          '<rect x="14" y="58" width="78" height="6" fill="#EFF6FF" stroke="#0171E3" stroke-width="1.5" stroke-dasharray="2 2"/>' +
          // Scissors (more detailed)
          '<g transform="translate(82 40) rotate(15)">' +
            // Blade 1
            '<path d="M0 0 L26 18 L24 22 L-2 4 Z" fill="#D0D0D0" stroke="#0F0F0E" stroke-width="1.2"/>' +
            // Blade 2
            '<path d="M0 0 L26 -18 L24 -22 L-2 -4 Z" fill="#D0D0D0" stroke="#0F0F0E" stroke-width="1.2"/>' +
            // Pivot
            '<circle cx="0" cy="0" r="2" fill="#0F0F0E"/>' +
            // Handle 1
            '<ellipse cx="-8" cy="-6" rx="6" ry="4" fill="none" stroke="#0F0F0E" stroke-width="1.5"/>' +
            // Handle 2
            '<ellipse cx="-8" cy="6" rx="6" ry="4" fill="none" stroke="#0F0F0E" stroke-width="1.5"/>' +
          '</g>' +
          // Cut line guide
          '<line x1="14" y1="61" x2="92" y2="61" stroke="#0171E3" stroke-width="0.8" stroke-dasharray="1 1"/>' +
          // Label
          '<text x="60" y="98" font-family="DM Sans, sans-serif" font-size="8" fill="#0171E3" font-weight="700" text-anchor="middle">Tira fina de papel</text>' +
          '<text x="60" y="108" font-family="DM Sans, sans-serif" font-size="6.5" fill="#6B6B66" text-anchor="middle">~ 8 cm de comprimento</text>' +
          '</svg>',
        text: 'Corte uma tira fina de papel, com uns 8 cm de comprimento, fina o suficiente para enrolar no dedo.'
      },
      {
        svg: '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<defs>' +
            '<linearGradient id="haloSkin" x1="0" y1="0" x2="1" y2="0">' +
              '<stop offset="0%" stop-color="#E5B58A"/>' +
              '<stop offset="50%" stop-color="#F4C9A0"/>' +
              '<stop offset="100%" stop-color="#D9A578"/>' +
            '</linearGradient>' +
          '</defs>' +
          // Finger viewed from front, vertical orientation (tip at top)
          // Main finger body (slightly tapered toward tip)
          '<path d="M44 22 Q44 14 52 14 L68 14 Q76 14 76 22 L78 100 Q78 108 70 108 L50 108 Q42 108 42 100 Z" fill="url(#haloSkin)" stroke="#0F0F0E" stroke-width="1.5" stroke-linejoin="round"/>' +
          // Fingernail
          '<path d="M50 16 Q60 13 70 16 L70 24 Q60 26 50 24 Z" fill="#FBE4CC" stroke="#0F0F0E" stroke-width="0.8" stroke-linejoin="round"/>' +
          // Knuckle wrinkle line
          '<path d="M44 38 Q60 36 76 38" stroke="#B8895E" stroke-width="0.7" fill="none" opacity=".55"/>' +
          // Paper strip wrapped around finger (with proper 3D ellipse perspective)
          // Back half of strip (behind finger - lighter)
          '<path d="M42 56 Q60 50 78 56 L78 66 Q60 60 42 66 Z" fill="#E0EBFA" stroke="#0171E3" stroke-width="1" opacity=".55"/>' +
          // Front half of strip (in front of finger - more visible)
          '<path d="M42 56 Q60 64 78 56 L78 66 Q60 74 42 66 Z" fill="#FFF" stroke="#0171E3" stroke-width="1.6"/>' +
          // Strip end on the LEFT extending beyond finger
          '<path d="M42 56 L18 50 Q14 50 14 53 L14 60 Q14 63 18 63 L42 63 Z" fill="#FFF" stroke="#0171E3" stroke-width="1.5" stroke-linejoin="round"/>' +
          // Strip end on the RIGHT extending and OVERLAPPING with the left end (overlap visible)
          '<path d="M78 56 L96 51 Q102 51 102 55 L102 62 Q102 65 96 65 L78 65 Z" fill="#FFF" stroke="#0171E3" stroke-width="1.5" stroke-linejoin="round"/>' +
          // Pen mark (red) at the OVERLAP point (where the right strip starts going under)
          '<g>' +
            '<circle cx="96" cy="58" r="3.5" fill="#DC2626"/>' +
            '<circle cx="96" cy="58" r="5.5" fill="none" stroke="#DC2626" stroke-width="1" opacity=".5"/>' +
            '<circle cx="96" cy="58" r="8" fill="none" stroke="#DC2626" stroke-width="0.6" opacity=".25"/>' +
          '</g>' +
          // Arrow pointing to the mark
          '<path d="M104 30 Q104 42 100 50" stroke="#DC2626" stroke-width="1.4" stroke-linecap="round" fill="none"/>' +
          '<path d="M97 49 L100 52 L102 48" stroke="#DC2626" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
          '<text x="116" y="22" font-family="DM Sans, sans-serif" font-size="6.5" fill="#DC2626" font-weight="700" text-anchor="end">marque aqui</text>' +
          '<text x="116" y="29" font-family="DM Sans, sans-serif" font-size="5.5" fill="#6B6B66" text-anchor="end">onde sobrepõe</text>' +
          // Label below
          '<text x="60" y="119" font-family="DM Sans, sans-serif" font-size="7.5" fill="#0171E3" font-weight="700" text-anchor="middle">Tira enrolada no dedo</text>' +
          '</svg>',
        text: 'Enrole no dedo anelar (mão não-dominante). Onde a tira sobrepõe, marque com caneta.'
      },
      {
        svg: '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          // Ruler (detailed with mm markings)
          '<rect x="6" y="44" width="108" height="14" fill="#FFF8E1" stroke="#0F0F0E" stroke-width="1.5"/>' +
          // Major ticks every 10mm with labels
          '<line x1="12" y1="44" x2="12" y2="54" stroke="#0F0F0E" stroke-width="1"/><text x="12" y="42" font-family="DM Mono, monospace" font-size="4" fill="#0F0F0E" text-anchor="middle">0</text><line x1="22" y1="44" x2="22" y2="54" stroke="#0F0F0E" stroke-width="1"/><text x="22" y="42" font-family="DM Mono, monospace" font-size="4" fill="#0F0F0E" text-anchor="middle">10</text><line x1="32" y1="44" x2="32" y2="54" stroke="#0F0F0E" stroke-width="1"/><text x="32" y="42" font-family="DM Mono, monospace" font-size="4" fill="#0F0F0E" text-anchor="middle">20</text><line x1="42" y1="44" x2="42" y2="54" stroke="#0F0F0E" stroke-width="1"/><text x="42" y="42" font-family="DM Mono, monospace" font-size="4" fill="#0F0F0E" text-anchor="middle">30</text><line x1="52" y1="44" x2="52" y2="54" stroke="#0F0F0E" stroke-width="1"/><text x="52" y="42" font-family="DM Mono, monospace" font-size="4" fill="#0F0F0E" text-anchor="middle">40</text><line x1="62" y1="44" x2="62" y2="54" stroke="#0F0F0E" stroke-width="1"/><text x="62" y="42" font-family="DM Mono, monospace" font-size="4" fill="#0F0F0E" text-anchor="middle">50</text><line x1="72" y1="44" x2="72" y2="54" stroke="#0F0F0E" stroke-width="1"/><text x="72" y="42" font-family="DM Mono, monospace" font-size="4" fill="#0F0F0E" text-anchor="middle">60</text><line x1="82" y1="44" x2="82" y2="54" stroke="#0F0F0E" stroke-width="1"/><text x="82" y="42" font-family="DM Mono, monospace" font-size="4" fill="#0F0F0E" text-anchor="middle">70</text><line x1="92" y1="44" x2="92" y2="54" stroke="#0F0F0E" stroke-width="1"/><text x="92" y="42" font-family="DM Mono, monospace" font-size="4" fill="#0F0F0E" text-anchor="middle">80</text><line x1="102" y1="44" x2="102" y2="54" stroke="#0F0F0E" stroke-width="1"/><text x="102" y="42" font-family="DM Mono, monospace" font-size="4" fill="#0F0F0E" text-anchor="middle">90</text><line x1="112" y1="44" x2="112" y2="54" stroke="#0F0F0E" stroke-width="1"/><text x="112" y="42" font-family="DM Mono, monospace" font-size="4" fill="#0F0F0E" text-anchor="middle">100</text><line x1="13" y1="44" x2="13" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="14" y1="44" x2="14" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="15" y1="44" x2="15" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="16" y1="44" x2="16" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="17" y1="44" x2="17" y2="50" stroke="#0F0F0E" stroke-width="0.5"/><line x1="18" y1="44" x2="18" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="19" y1="44" x2="19" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="20" y1="44" x2="20" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="21" y1="44" x2="21" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="23" y1="44" x2="23" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="24" y1="44" x2="24" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="25" y1="44" x2="25" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="26" y1="44" x2="26" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="27" y1="44" x2="27" y2="50" stroke="#0F0F0E" stroke-width="0.5"/><line x1="28" y1="44" x2="28" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="29" y1="44" x2="29" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="30" y1="44" x2="30" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="31" y1="44" x2="31" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="33" y1="44" x2="33" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="34" y1="44" x2="34" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="35" y1="44" x2="35" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="36" y1="44" x2="36" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="37" y1="44" x2="37" y2="50" stroke="#0F0F0E" stroke-width="0.5"/><line x1="38" y1="44" x2="38" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="39" y1="44" x2="39" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="40" y1="44" x2="40" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="41" y1="44" x2="41" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="43" y1="44" x2="43" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="44" y1="44" x2="44" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="45" y1="44" x2="45" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="46" y1="44" x2="46" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="47" y1="44" x2="47" y2="50" stroke="#0F0F0E" stroke-width="0.5"/><line x1="48" y1="44" x2="48" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="49" y1="44" x2="49" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="50" y1="44" x2="50" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="51" y1="44" x2="51" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="53" y1="44" x2="53" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="54" y1="44" x2="54" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="55" y1="44" x2="55" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="56" y1="44" x2="56" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="57" y1="44" x2="57" y2="50" stroke="#0F0F0E" stroke-width="0.5"/><line x1="58" y1="44" x2="58" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="59" y1="44" x2="59" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="60" y1="44" x2="60" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="61" y1="44" x2="61" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="63" y1="44" x2="63" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="64" y1="44" x2="64" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="65" y1="44" x2="65" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="66" y1="44" x2="66" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="67" y1="44" x2="67" y2="50" stroke="#0F0F0E" stroke-width="0.5"/><line x1="68" y1="44" x2="68" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="69" y1="44" x2="69" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="70" y1="44" x2="70" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="71" y1="44" x2="71" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="73" y1="44" x2="73" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="74" y1="44" x2="74" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="75" y1="44" x2="75" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="76" y1="44" x2="76" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="77" y1="44" x2="77" y2="50" stroke="#0F0F0E" stroke-width="0.5"/><line x1="78" y1="44" x2="78" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="79" y1="44" x2="79" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="80" y1="44" x2="80" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="81" y1="44" x2="81" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="83" y1="44" x2="83" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="84" y1="44" x2="84" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="85" y1="44" x2="85" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="86" y1="44" x2="86" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="87" y1="44" x2="87" y2="50" stroke="#0F0F0E" stroke-width="0.5"/><line x1="88" y1="44" x2="88" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="89" y1="44" x2="89" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="90" y1="44" x2="90" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="91" y1="44" x2="91" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="93" y1="44" x2="93" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="94" y1="44" x2="94" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="95" y1="44" x2="95" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="96" y1="44" x2="96" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="97" y1="44" x2="97" y2="50" stroke="#0F0F0E" stroke-width="0.5"/><line x1="98" y1="44" x2="98" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="99" y1="44" x2="99" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="100" y1="44" x2="100" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="101" y1="44" x2="101" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="103" y1="44" x2="103" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="104" y1="44" x2="104" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="105" y1="44" x2="105" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="106" y1="44" x2="106" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="107" y1="44" x2="107" y2="50" stroke="#0F0F0E" stroke-width="0.5"/><line x1="108" y1="44" x2="108" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="109" y1="44" x2="109" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="110" y1="44" x2="110" y2="47" stroke="#0F0F0E" stroke-width="0.5"/><line x1="111" y1="44" x2="111" y2="47" stroke="#0F0F0E" stroke-width="0.5"/>' +
          // Paper strip on top of ruler (opened/flat now)
          '<rect x="14" y="62" width="60" height="6" fill="#FFF" stroke="#0171E3" stroke-width="1.2"/>' +
          // Blue dot at start
          '<circle cx="14" cy="65" r="2.5" fill="#0171E3" stroke="#FFF" stroke-width="1"/>' +
          // Red dot at the mark (60mm = end position)
          '<circle cx="74" cy="65" r="2.5" fill="#DC2626" stroke="#FFF" stroke-width="1"/>' +
          // Measurement bracket
          '<path d="M14 76 L14 80 L74 80 L74 76" stroke="#0171E3" stroke-width="1.2" fill="none" stroke-linecap="round"/>' +
          '<line x1="44" y1="80" x2="44" y2="84" stroke="#0171E3" stroke-width="1.2"/>' +
          // Big measurement readout
          '<rect x="32" y="86" width="56" height="16" rx="3" fill="#EFF6FF" stroke="#0171E3" stroke-width="1.5"/>' +
          '<text x="60" y="97" font-family="DM Mono, monospace" font-size="9" fill="#0171E3" font-weight="700" text-anchor="middle">60 mm</text>' +
          // Helper text
          '<text x="60" y="114" font-family="DM Sans, sans-serif" font-size="6.5" fill="#6B6B66" text-anchor="middle">esse é o valor da circunferência</text>' +
          '</svg>',
        text: 'Abra a tira e meça com uma régua em milímetros. Esse é o valor da circunferência do dedo.'
      }
    ]
  },
  ring: {
    title: 'Como ajustar o anel',
    steps: [
      {
        svg: '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          // Phone (vertical)
          '<rect x="28" y="8" width="64" height="104" rx="8" fill="#1a1a1a" stroke="#0F0F0E" stroke-width="1.5"/>' +
          '<rect x="32" y="15" width="56" height="90" rx="2" fill="#F8F8F7"/>' +
          '<rect x="50" y="8" width="20" height="3" rx="1.5" fill="#0F0F0E"/>' +
          // Blue circle on screen (sizer)
          '<circle cx="60" cy="60" r="20" fill="rgba(1,113,227,0.08)" stroke="#0171E3" stroke-width="2"/>' +
          '<circle cx="60" cy="60" r="14" fill="#F8F8F7"/>' +
          // Ring placed on top of screen (3D ellipse for perspective)
          '<g transform="translate(0 -2)">' +
            '<ellipse cx="60" cy="58" rx="18" ry="6" fill="#2a2a2a" stroke="#0F0F0E" stroke-width="1.5"/>' +
            '<ellipse cx="60" cy="58" rx="18" ry="6" fill="url(#ringGrad)" opacity=".7"/>' +
            '<ellipse cx="60" cy="58" rx="11" ry="3.5" fill="#F8F8F7"/>' +
            '<defs><linearGradient id="ringGrad" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#666"/><stop offset="100%" stop-color="#0F0F0E"/></linearGradient></defs>' +
            // LEDs on inner side
            '<circle cx="55" cy="61" r="0.8" fill="#0171E3"/>' +
            '<circle cx="60" cy="61.5" r="0.8" fill="#15803D"/>' +
            '<circle cx="65" cy="61" r="0.8" fill="#0171E3"/>' +
          '</g>' +
          // Down arrow showing "place on screen"
          '<path d="M105 28 Q105 40 96 50" stroke="#0171E3" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="2 2" fill="none"/>' +
          '<path d="M93 47 L96 50 L99 47" stroke="#0171E3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
          // Label
          '<text x="60" y="100" font-family="DM Sans, sans-serif" font-size="8" fill="#0171E3" font-weight="700" text-anchor="middle">Anel sobre a tela</text>' +
          '</svg>',
        text: 'Coloque seu anel diretamente sobre a tela do celular, no centro.'
      },
      {
        svg: '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          // Outer ring (real ring, top-down view)
          '<circle cx="60" cy="56" r="32" fill="#1a1a1a" stroke="#0F0F0E" stroke-width="2"/>' +
          '<circle cx="60" cy="56" r="32" fill="url(#rg2)" opacity=".5"/>' +
          '<defs><radialGradient id="rg2" cx="40%" cy="30%"><stop offset="0%" stop-color="#888"/><stop offset="100%" stop-color="transparent"/></radialGradient></defs>' +
          // Inner ring hole (target)
          '<circle cx="60" cy="56" r="22" fill="#F8F8F7"/>' +
          // Blue sizer circle (matches inner)
          '<circle cx="60" cy="56" r="22" fill="none" stroke="#0171E3" stroke-width="2.5" stroke-dasharray="4 3"/>' +
          // Drag handle on the right
          '<circle cx="82" cy="56" r="4.5" fill="#0171E3" stroke="#FFF" stroke-width="2"/>' +
          // Arrows showing it can resize
          '<path d="M90 56 L100 56 M96 52 L100 56 L96 60" stroke="#0171E3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
          '<path d="M30 56 L20 56 M24 52 L20 56 L24 60" stroke="#0171E3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
          // Inner highlight
          '<text x="60" y="60" font-family="DM Sans, sans-serif" font-size="7" fill="#0171E3" font-weight="700" text-anchor="middle">interno</text>' +
          // Label
          '<text x="60" y="104" font-family="DM Sans, sans-serif" font-size="8" fill="#0171E3" font-weight="700" text-anchor="middle">Ajuste ao diâmetro interno</text>' +
          '<text x="60" y="113" font-family="DM Sans, sans-serif" font-size="6.5" fill="#6B6B66" text-anchor="middle">arraste a bolinha azul</text>' +
          '</svg>',
        text: 'Arraste a bolinha azul até o círculo encaixar exatamente no diâmetro interno do anel.'
      },
      {
        svg: '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          // Result card
          '<rect x="14" y="30" width="92" height="60" rx="10" fill="rgba(239,246,255,0.6)" stroke="#0171E3" stroke-width="2"/>' +
          // Top label
          '<text x="60" y="46" font-family="DM Mono, monospace" font-size="6" fill="#0171E3" font-weight="600" text-anchor="middle" letter-spacing=".8">SEU TAMANHO HALO</text>' +
          // Big number
          '<text x="60" y="78" font-family="DM Sans, sans-serif" font-size="36" font-weight="800" fill="#0171E3" text-anchor="middle" letter-spacing="-2">10</text>' +
          // Diameter info
          '<rect x="32" y="94" width="56" height="14" rx="7" fill="#FFF" stroke="#0171E3" stroke-width="1" opacity=".7"/>' +
          '<text x="60" y="103" font-family="DM Mono, monospace" font-size="6.5" fill="#0171E3" font-weight="600" text-anchor="middle">Ø 19,5 mm</text>' +
          // Confetti dots (celebration)
          '<circle cx="20" cy="20" r="1.8" fill="#0171E3"/>' +
          '<circle cx="100" cy="22" r="1.5" fill="#15803D"/>' +
          '<circle cx="14" cy="98" r="1.5" fill="#F79E1B"/>' +
          '<circle cx="106" cy="100" r="2" fill="#0171E3"/>' +
          '<circle cx="60" cy="14" r="1.2" fill="#15803D"/>' +
          '</svg>',
        text: 'O tamanho recomendado aparece em destaque. Pronto, é só selecionar acima.'
      }
    ]
  }
};

function haloShowHelp(type) {
  var data = HELP_CONTENT[type];
  if (!data) return;
  var modal = document.getElementById('halo-modal');
  var title = document.getElementById('halo-modal-title');
  var body = document.getElementById('halo-modal-body');
  if (!modal || !title || !body) return;

  // Move modal to <body> on first show to escape any parent stacking context
  if (modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  title.textContent = data.title;
  var html = '';
  for (var i = 0; i < data.steps.length; i++) {
    html += '<div class="halo-help-step">'
         + '<div class="halo-help-num">' + (i + 1) + '</div>'
         + '<div class="halo-help-svg">' + data.steps[i].svg + '</div>'
         + '<div class="halo-help-txt">' + data.steps[i].text + '</div>'
         + '</div>';
  }
  body.innerHTML = html;
  modal.classList.add('show');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function haloHideHelp() {
  var modal = document.getElementById('halo-modal');
  if (!modal) return;
  modal.classList.remove('show');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

/* ─── EVENTS (direct bindings) ─── */
function haloAttach() {
  function on(id, evt, fn) {
    var el = document.getElementById(id);
    if (!el) return;
    var k = '_h_' + evt;
    if (el[k]) return;
    el[k] = true;
    el.addEventListener(evt, fn);
  }
  function onAll(sel, evt, fn) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var k = '_h_' + evt;
      if (el[k]) continue;
      el[k] = true;
      el.addEventListener(evt, fn);
    }
  }

  on('halo-disc', 'click', haloToggleG);

  onAll('[data-halo="tab"]', 'click', function() {
    haloPT(parseInt(this.getAttribute('data-tab')));
  });

  on('halo-ch', 'mousedown', cS);
  on('halo-ch', 'touchstart', cS);
  on('halo-confirm-calib', 'click', haloConfirmCalib);

  on('halo-rhand', 'mousedown', rS);
  on('halo-rhand', 'touchstart', rS);
  on('halo-sl', 'input', function() { haloOnSl(this.value); });
  onAll('[data-halo="nudge"]', 'click', function() {
    haloNudge(parseInt(this.getAttribute('data-dir')));
  });

  on('halo-vc', 'input', haloCalcB);

  onAll('[data-halo="help"]', 'click', function() {
    haloShowHelp(this.getAttribute('data-help'));
  });
  onAll('[data-halo="close-modal"]', 'click', haloHideHelp);

  // Close modal on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') haloHideHelp();
  });
}

window.addEventListener('mousemove', function(e) { cM(e); rM(e); });
window.addEventListener('touchmove', function(e) { cM(e); rM(e); }, { passive: false });
window.addEventListener('mouseup',   function() { cE(); rE(); });
window.addEventListener('touchend',  function() { cE(); rE(); });

/* ─── INIT ─── */
window.__haloInit = window.__haloInit || false;
function haloInit() {
  if (window.__haloInit) return;
  if (!document.getElementById('halo-disc')) return;
  window.__haloInit = true;
  console.log('[HALO] init');
  haloBuildTable();
  haloAttach();
}
haloInit();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', haloInit);
window.addEventListener('load', haloInit);

/* Debug */
window.__haloDebug = function() {
  return {
    discFound: !!document.getElementById('halo-disc'),
    gwFound: !!document.getElementById('halo-gw'),
    haloToggleG: typeof haloToggleG,
    initialized: window.__haloInit
  };
};
window.haloToggleG = haloToggleG;